import { IconChevronRight } from '@tabler/icons-react'

export default function TitleBreadcrumb({ title, fullWidth = false }) {
    let crumbs = title
    if (typeof crumbs === 'string') crumbs = [{ title: crumbs }]
    if (!crumbs) return null

    return (
        <div className={'title-breadcrumb csf-2 mt-3 mb-3' + (!fullWidth ? ' screen-body' : '')}>
            {crumbs.map((item, index) => (
                <>
                    {index !== 0 && <IconChevronRight />}
                    {item.iconLeft || null}
                    <h5
                        key={index}
                        className={`${item.url ? 'pressable' : ''}`}
                        onClick={() => (item.url ? window.navigate(item.url) : null)}
                    >
                        {item.title}
                    </h5>
                    {item.iconRight || null}
                </>
            ))}
        </div>
    )
}
